"use client";

// PostHog provider — makes the posthog-js singleton available via usePostHog() for any
// component in the tree. The singleton is initialised by PostHogInit
// (components/analytics/PostHogInit.tsx), in a useEffect after hydration commits; we
// simply pass it through here.
// See: https://posthog.com/docs/libraries/next-js#app-router

import posthog from "posthog-js";
import { PostHogProvider } from "posthog-js/react";

export function Providers({ children }: { children: React.ReactNode }) {
  return <PostHogProvider client={posthog}>{children}</PostHogProvider>;
}
